var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "draw-layer" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "bg-02" }, [
        _c("div", { staticClass: "con account" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "right-part" }, [
            _c("div", { staticClass: "r-con" }, [
              _vm.isBind
                ? _c("div", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c("p", [
                        _vm._v("角色名：" + _vm._s(this.roleInfo.roleName))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("所属大区：盘古大陆")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("活动专服: 龙余仙岛 ")])
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c(
                        "li",
                        { staticClass: "animate-pictrue bind3" },
                        [
                          _c("router-link", {
                            attrs: {
                              tag: "a",
                              target: "_blank",
                              to: { name: "Online" }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.unBind
                ? _c("ul", [
                    _c(
                      "li",
                      {
                        staticClass: "animate-pictrue bind1",
                        on: { click: _vm.bindRole }
                      },
                      [_c("a", { attrs: { href: "javascript:void(0)" } })]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "animate-pictrue bind3" },
                      [
                        _c("router-link", {
                          attrs: {
                            tag: "a",
                            target: "_blank",
                            to: { name: "Online" }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isLogin
                ? _c("ul", [
                    _vm._m(4),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "animate-pictrue btn4" },
                      [
                        _c("router-link", {
                          attrs: {
                            tag: "a",
                            target: "_blank",
                            to: { name: "Online" }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-03" }, [
        _c(
          "div",
          { staticClass: "con" },
          [
            _c("lucky-spin", {
              attrs: { loginStatus: _vm.loginStatus },
              on: {
                awardsResult: _vm.getAwardResult,
                bindAccount: _vm.goBindAccount
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定角色",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "pop-con" },
            [
              _c("p", [_vm._v("活动大区：盘古大陆")]),
              _vm._v(" "),
              _c("p", [_vm._v("活动专服: 龙余仙岛 ")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "0"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "roles" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择角色" },
                          model: {
                            value: _vm.ruleForm.roles,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "roles", $$v)
                            },
                            expression: "ruleForm.roles"
                          }
                        },
                        _vm._l(_vm.roleList, function(item) {
                          return _c("el-option", {
                            key: item.roleId,
                            attrs: {
                              label: item.roleName,
                              value: item.roleName
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.createRole("ruleForm")
                    }
                  }
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-01" }, [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", {
            attrs: {
              src: require("../../assets/images/draw/logo.png"),
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "back" }, [
          _c(
            "a",
            { attrs: { target: "_blank", href: "http://fmz.ourgame.com/" } },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/images/draw/back.png"),
                  alt: ""
                }
              })
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-part" }, [
      _c("div", { staticClass: "p-con" }, [
        _c("p", [_vm._v("活动时间: "), _c("br"), _vm._v("7月13日至7月19日 ")]),
        _vm._v(" "),
        _c("p", [_vm._v("活动专服: 龙余仙岛 ")]),
        _vm._v(" "),
        _c("p", [_vm._v("活动规则：")]),
        _vm._v(" "),
        _c("div", { staticClass: "rule" }, [
          _c("ul", [
            _c("li", [
              _c("p", [
                _vm._v(
                  "1）开服前，仙友们每天可获得1次抽奖机会（当日24点清零，不可累加）"
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v("2）每日参与将会获得额外境界礼包奖励")])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _vm._v(
                  "3）累计参与抽奖3次可获得境界礼包“初窥”、累计参与抽奖6次可获得境界礼包“大乘”、累计参与抽奖10次可获得境界礼包“成圣”。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _vm._v(
                  "4）境界礼包中获得的道具“幻海锦绸”收集10份即可合成永久时装“澜歌幻海”"
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [_vm._v("5）所有奖励将于开服后统一发放至绑定的角色邮箱")])
            ]),
            _vm._v(" "),
            _c("li", [_c("p", [_vm._v("6）恶意刷奖行为将被永久封停账号")])])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "close" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=http://fmz.ourgame.com/activity/index.html/#/online"
          }
        },
        [_vm._v("退出")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "animate-pictrue bind2" }, [
      _c("a", {
        attrs: {
          target: "_blank",
          href: "http://fmz.ourgame.com/contents/22/26.html"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "animate-pictrue btn1" }, [
      _c("a", {
        attrs: {
          target: "_blank",
          href:
            "http://passport.ourgame.com/passportlogin.do?from=ourgame&nexturl=http://fmz.ourgame.com/activity/index.html#/luckyDraw"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "animate-pictrue btn2" }, [
      _c("a", {
        attrs: {
          target: "_blank",
          href: "http://id.ourgame.com/regist.do?third_company=fumozhuan"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "animate-pictrue btn3" }, [
      _c("a", {
        attrs: {
          target: "_blank",
          href: "http://fmz.ourgame.com/contents/22/26.html"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-04" }, [
      _c("div", { staticClass: "content" }, [
        _c("footer", [
          _c("p", [
            _vm._v(
              "积极健康的游戏心态是健康游戏的开端，本游戏故事情节设置紧凑，请您合理控制游戏时间，避免沉溺游戏影响生活，注意自我保护，防范网络陷阱。"
            ),
            _c("br"),
            _vm._v(
              "\n网络文化经营许可证　京网文[2018]5376-415号 软著登字第1387887号 新广出审【2016】881号"
            ),
            _c("br"),
            _vm._v(
              "\n网络游戏出版物号ISBN 978-7-89988-744-8 沪新出科数【2016】301号 网站备案号: "
            ),
            _c(
              "a",
              {
                attrs: { target: "_blank", href: "https://beian.miit.gov.cn/" }
              },
              [_vm._v("京ICP备09074391号-2")]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7c1a8ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7c1a8ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/special/LuckyDraw.vue
// module id = null
// module chunks = 